import React, { Component } from 'react'
import { connect } from 'react-redux'
import CalendarSwitcher from '../Components/CalendarSwitcher'
import { toggleCalendar } from '../store/actions'
import { TOOLTIP_STATES, ENABLE_CALENDAR_ID } from '../constants'

const mapStateToProps = state => {
    return {
        tooltip: state.main.tooltipType,
        calendars: state.calendars
    }
}

class CalendarSwitcherContainer extends Component {
    clickHander = event => {
        this.props.dispatch(toggleCalendar(event.id))
    }

    isShowTooltip = () => {
        return (
            this.props.id === ENABLE_CALENDAR_ID &&
            (this.props.tooltip === TOOLTIP_STATES.SWITCH_ON_OFF ||
                this.props.tooltip === TOOLTIP_STATES.SELECT_CALENDARS)
        )
    }

    render() {
        return (
            <CalendarSwitcher
                {...this.props}
                showMarker={this.isShowTooltip()}
                onClick={this.clickHander}
            />
        )
    }
}

export default connect(mapStateToProps)(CalendarSwitcherContainer)
